var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Breadcrumbs',{attrs:{"title":"Dropzone"}}),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }